import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-owl-carousel',
  templateUrl: './owl-carousel.component.html',
  styleUrls: ['./owl-carousel.component.scss']
})
export class OwlCarouselComponent implements OnInit {
    public isSkeleton: boolean = true;
  @ViewChild('carousel', { static: false }) carousel!: CarouselComponent;
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() origin?: string = '';
  @Input() zIndex?: number = 1;
  @Input() contents: any[] = [
    { isSkeleton: true },
    { isSkeleton: true },
    { isSkeleton: true },
    { isSkeleton: true },
    { isSkeleton: true }
  ];
  carouselOptions: OwlOptions = {
    loop: true,
    margin: 14, // Espacio entre los elementos
    stagePadding: 14, // Espacio en los lados del carrusel
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 400,
    nav: false,
    navText: ['', ''],
    center: false,
    startPosition: 0,
    items: 4,
    responsive: {
      0: {
        items: 1 // Muestra 1 elemento en pantallas pequeñas
      },
      425: {
        items: 1
      },
      540: {
        items: 1
      },
      600: {
        items: 2 // Muestra 2 elementos en pantallas medianas
      },
      768: {
        items: 4 // Muestra 3 elementos en pantallas medianas
      },
      1360: {
        items: 4 // Muestra 4 elementos en pantallas grandes
      },
      1536: {
        items: 4 // Muestra 4 elementos en pantallas grandes
      },
      1600: {
        items: 5 // Muestra 5 elementos en pantallas grandes
      }
    }
  };

  
  public visibleItemsCount = 5;

  get emptySlots(): any[] {
      const emptyCount = Math.max(this.visibleItemsCount - this.contents.length, 0);
      return Array(emptyCount);
  }

  constructor() { }

  ngOnInit(): void {
 //  Simulacion de carga skeleton titleCarousel
       setTimeout(() => {
      this.isSkeleton = false;
    }, 200); //  2 segundos de carga simulada
  }

  public prev(): void {
    this.carousel.prev();
  }

  public next(): void {
    this.carousel.next();
  }
}
